import { PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js"
import React, { useState, useEffect } from "react"
import { Button } from "components/Button"
import { GenericModal } from "components/Modal/Modal"
import { languages } from "lib/languages"
import styles from './Stripe.module.scss';
import { first } from "lodash"
import { useDispatch } from "react-redux"
import actions from 'containers/Stripe/services/actions'
import { PAYMENT_ERROR } from "./services/constants"

export const PaymentCardForm: React.FC<
  Partial<any> & { onPay: (a: any[]) => void }
> = (props): JSX.Element => {
  const [paymentRefusedModalVisible, setPaymentRefusedModalVisible] =
    useState<boolean>(false);
  const [wishToAddPaymentMethod, setWishToAddPaymentMethod] =
    useState<boolean>(false);
  const [loadingComponent, setLoadingComponent] = useState<boolean>(true);

  const stripe = useStripe()
  const elements = useElements()
  useState<boolean>(true)

  const dispatch = useDispatch();

  useEffect(() => {
    if (!props.cards && props.get) props.get()
    if (first(props.cards)) {
      setWishToAddPaymentMethod(false)
    }
  }, [props.cards])

  useEffect(() => {
    setPaymentRefusedModalVisible(props.hasPaymentError ?? false)
  }, [props.hasPaymentError])

  const handleSubmit = async (event?: any) => {
    event?.preventDefault?.();
    dispatch({ type: "SET_PAYMENT_LOADING" })
    if (!stripe || !elements) {
      console.error('no stripe, no elements');
      return;
    }

    const config: any = { redirect: "if_required" }

    const { error, ...rest } = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      ...config
    })
    if (/incomplete/.test(error?.code)) {
      return dispatch({ type: "PAYMENT_ERROR" })
    }
    if (error) {
      console.error('error : ', error);
      setPaymentRefusedModalVisible(true);
      dispatch({ type: PAYMENT_ERROR, payload: { text: error.message, type: 'error' } });
    } else {
      // Verify against Stripe that the payment intent is really authorized
      // (manual capture: the expected status is "requires_capture")
      const clientSecret =
        rest?.paymentIntent?.client_secret ??
        props.paymentIntent?.paymentintent?.client_secret
      const { error: retrieveError, paymentIntent } =
        await stripe.retrievePaymentIntent(clientSecret)
      if (retrieveError || paymentIntent?.status !== "requires_capture") {
        console.error('payment intent not authorized : ', retrieveError ?? paymentIntent?.status);
        setPaymentRefusedModalVisible(true);
        dispatch({
          type: PAYMENT_ERROR,
          payload: retrieveError?.message
            ? { text: retrieveError.message, type: 'error' }
            : undefined,
        })
        return;
      }
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
      // NdlA : On ne passe là qu'en local, car la redirection n'est pas required
      props.onPay([{
        value: [rest?.paymentIntent?.id ?? props.paymentIntent?.paymentintent.id],
        questionId: "payment_sheet_intent_id"
      }])
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div>
          <div className={styles.Grid}>{languages.byCard}</div>
          <PaymentElement
            onReady={() => {
              setLoadingComponent(false);
            }}
            options={{
              layout: {
                type: "accordion",
                radios: "never"
              }
            }} />
          <div className={styles.Centered}>
            <Button wide="default" style={{ marginTop: '45px' }} loading={props.loading || loadingComponent} type="primary" >{languages.pay} {props?.price?.ophtalmologist?.price} {languages.euroDevice}</Button>
          </div>
        </div>
      </form>
      <GenericModal
        visible={paymentRefusedModalVisible}
        iconError
        titleProps={{ size: "small" }}
        title={languages.errorPaymentModalTitle}
        contentText={languages.errorPaymentModal_html}
        acceptButtonProps={{ danger: false }}
        acceptText={languages.errorPaymentModalRetry}
        cancelText={languages.errorPaymentModalChangeCard}
        onAccept={() => {
          setPaymentRefusedModalVisible(false)
          dispatch(actions.hasStripeError(false))
          // Si l'utilisateur est au paiement, on le lance à nouveau
          !wishToAddPaymentMethod && handleSubmit()
        }}
        onCancel={() => {
          setPaymentRefusedModalVisible(false)
          setWishToAddPaymentMethod(true)
        }}
      ></GenericModal>
    </div>
  )
}